
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * CommissionType enum
 */
class CommissionType {
  /**
   * Initialize enum with a given value
   * @param {CommissionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof CommissionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!CommissionType}
   * @param {!CommissionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CommissionType)) {
      throw new TypeError('Instance of CommissionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!CommissionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!CommissionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === CommissionType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === CommissionType.PER_LOT.value) {
      return 'PER_LOT'
    }
    if (this.value === CommissionType.PER_TRADE.value) {
      return 'PER_TRADE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!CommissionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!CommissionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!CommissionType} Created enum
   */
  static fromObject (other) {
    return new CommissionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
CommissionType.UNKNOWN = new CommissionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
CommissionType.PER_LOT = new CommissionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
CommissionType.PER_TRADE = new CommissionType(0 + 2)

export { CommissionType };

/**
 * Fast Binary Encoding CommissionType field model
 */
class FieldModelCommissionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelCommissionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelCommissionType}
   * @param {CommissionType=} defaults Default value, defaults is new CommissionType()
   * @returns {!CommissionType} Result value
   */
  get (defaults = new CommissionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new CommissionType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelCommissionType}
   * @param {!CommissionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelCommissionType };
